import React from 'react';
import { Divider } from '@chakra-ui/react';
import { useOutletContext } from 'react-router-dom';
import {
    getFullPaymentAmountText,
    getNextInstallment,
    getPartialPaymentAmountText
} from 'ts/common/components/invoice/helpers';
import { useTranslate } from 'ts/common/hooks';
import ClientPaymentOptions, {
    type ClientPaymentOption
} from 'client_react/common/components/ClientPaymentOptions';

interface Props {
    paymentAmountType: ClientPaymentOption;
    setPaymentAmountType: (x: ClientPaymentOption) => void;
}

const InvoicePaymentOptions = ({ paymentAmountType, setPaymentAmountType }: Props) => {
    const { invoice } = useOutletContext<{ invoice: SpApi.Client.IInvoice }>();
    const t = useTranslate('clientInvoice');

    const fullPaymentAmountText = getFullPaymentAmountText(invoice);
    const partialPaymentAmountText = getPartialPaymentAmountText(invoice);

    if (fullPaymentAmountText === partialPaymentAmountText) {
        return null;
    }

    const fullOptionText = t('payInFull', {
        price: fullPaymentAmountText
    });

    const nextInstallment = getNextInstallment(invoice);

    const nextInstallmentNumber =
        nextInstallment && invoice.installments.indexOf(nextInstallment) + 1;

    const retainerOptionText = t(
        !nextInstallmentNumber
            ? 'paymentOverdue'
            : nextInstallmentNumber === 1 && invoice.invoiceRetainerLabel
            ? 'payRetainer'
            : 'payInstallment',
        {
            installmentNumber: nextInstallmentNumber,
            invoiceRetainerLabel: invoice.invoiceRetainerLabel,
            price: partialPaymentAmountText
        }
    );

    return (
        <>
            <ClientPaymentOptions
                fullOptionText={fullOptionText}
                onChange={setPaymentAmountType}
                retainerOptionText={retainerOptionText}
                title={t('paymentOptions')}
                value={paymentAmountType}
            />
            <Divider />
        </>
    );
};

export default InvoicePaymentOptions;
